module.exports = __webpack_public_path__ + "img/jietu3.cf653251.png";